import { render, staticRenderFns } from "./SurveySubmitted.vue?vue&type=template&id=d9b53510&scoped=true"
import script from "./SurveySubmitted.vue?vue&type=script&lang=js"
export * from "./SurveySubmitted.vue?vue&type=script&lang=js"
import style0 from "./SurveySubmitted.vue?vue&type=style&index=0&id=d9b53510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b53510",
  null
  
)

export default component.exports